import type { ThemeConfig } from 'antd';

// Material 3 light scheme, выведена из seed = #0061A4 (Murmansk Blue).
// Маппинг M3 token → Ant Design ThemeConfig token.
export const md3Theme: ThemeConfig = {
  token: {
    // Brand
    colorPrimary: '#0061A4',
    colorInfo: '#0061A4',
    colorLink: '#0061A4',

    // Semantic (M3)
    colorSuccess: '#006C4C',
    colorWarning: '#7D5800',
    colorError: '#BA1A1A',

    // Surfaces (M3 Surface, выведены из seed #0061A4 — лёгкий голубой подтон)
    colorBgLayout: '#FDFCFF',
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FFFFFF',

    // Outline (M3 Outline / Outline Variant — голубо-серые)
    colorBorder: '#73777F',
    colorBorderSecondary: '#DFE2EB',

    // Shape (M3 corner radius scale)
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 8,
    borderRadiusXS: 4,

    // Typography (M3 — Roboto Flex)
    fontFamily:
      '"Roboto Flex", Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,

    // Touch targets (чуть компактнее M3 spec — больше полезного пространства)
    controlHeight: 36,
    controlHeightLG: 44,
    controlHeightSM: 28,

    // Компактные вертикальные паддинги
    padding: 12,
    paddingLG: 16,
    paddingSM: 8,
    paddingXS: 6,
    margin: 12,
    marginLG: 16,
    marginSM: 8,

    // Elevation level 1 (M3)
    boxShadow:
      '0 1px 2px 0 rgba(0,0,0,0.30), 0 1px 3px 1px rgba(0,0,0,0.15)',
    boxShadowSecondary:
      '0 1px 2px 0 rgba(0,0,0,0.30), 0 2px 6px 2px rgba(0,0,0,0.15)',
  },
  components: {
    Button: {
      // M3 filled / tonal — pill-shape
      borderRadius: 18,
      borderRadiusLG: 22,
      borderRadiusSM: 14,
      controlHeight: 36,
      paddingInline: 16,
    },
    Card: {
      borderRadiusLG: 16,
      paddingLG: 12,
    },
    Table: {
      cellPaddingBlock: 10,
      cellPaddingBlockMD: 8,
      cellPaddingBlockSM: 6,
    },
    Input: {
      borderRadius: 8,
    },
    Select: {
      borderRadius: 8,
    },
    Modal: {
      borderRadiusLG: 28,
    },
    Drawer: {
      borderRadiusLG: 16,
    },
    Tag: {
      borderRadiusSM: 8,
    },
  },
};
